import { replaceBraces } from "@timeedit/registration-shared";
import { ButtonProps, Typography } from "@timeedit/ui-components";
import { ReactNode, useState } from "react";
import { Translations } from "../types";
import { ButtonWithDescription } from "../ButtonWithDescription";
import { ConflictNotification } from "../../Conflict";
import { StatusModal } from "../../StatusModal";
import Queue from "@timeedit/ui-components/icons/Queue";
import WarningOutlined from "@timeedit/ui-components/icons/WarningOutlined";

type IsOnWaitlistButtonProps = {
  buttonProps: ButtonProps;
  description: ReactNode;
  clash: boolean;
  linkedIssue: boolean;
  translations: Translations;
  activityName: string;
  groupName: string;
  onLeaveWaitlist: () => void;
};
export function IsOnWaitlistButton({
  buttonProps,
  clash,
  description,
  translations,
  linkedIssue,
  activityName,
  groupName,
  onLeaveWaitlist,
}: IsOnWaitlistButtonProps): React.JSX.Element {
  const [waitlistLeaveOpen, setWaitlistLeaveOpen] = useState(false);
  return (
    <>
      <StatusModal
        open={waitlistLeaveOpen}
        title={translations.leaveWaitlistConfirmTitle}
        severity="Warning"
        okText={translations.leaveWaitlist}
        closeIcon={false}
        onOk={() => {
          onLeaveWaitlist();
          setWaitlistLeaveOpen(false);
        }}
        onCancel={() => setWaitlistLeaveOpen(false)}
        text={
          <Typography.Text>
            {replaceBraces(
              translations.leaveWaitlistConfirmText,
              groupName,
              activityName
            )}
          </Typography.Text>
        }
      />
      <ButtonWithDescription
        {...buttonProps}
        isWaitlist
        description={description}
        icon={<Queue aria-hidden />}
        label={`${translations.inWaitlist}. ${translations.clickToLeaveWaitlist}`}
        onClick={() => setWaitlistLeaveOpen(true)}
      >
        {translations.inWaitlist}
      </ButtonWithDescription>
      {clash && <ConflictNotification useText />}
      {linkedIssue && (
        <WarningOutlined
          className={"allocation-container--icon"}
          alt="Linked issue present"
        />
      )}
    </>
  );
}
